<template>
    <!--   </v-container>-->
    <v-sheet style="background-color:#fff;height:100%">
        <v-card elevation="0">
            <v-card-title>
            Produtos
            <div class="flex-grow-1"></div>
            <v-text-field
                v-model="search"
                append-icon="search"
                label="Buscar produtos"
                single-line
                hide-details
            ></v-text-field>
            </v-card-title>
            <v-data-table
            :headers="headers"
            :items="products"
            :search="search"
            >
            

            <template v-slot:item.cover="{item}">                
                <v-img
                    width="70px"
                    v-if="item.thumbnail"
                    :src="get_cover_url(item)"
                />
            </template>

             <template v-slot:item.actions="{ item }">
                    <v-btn icon text :to="{name:'product_edit_video',params:{id:item.id}}">
                       &nbsp;<v-icon small class="mr-2">edit</v-icon>
                    </v-btn>
                </template>
            
            </v-data-table>
        </v-card>
    </v-sheet>
</template>

<script>
import ProductService from "../../../../app/rest/products"

var productService = null;

export default {
    components:{ },
    data: () => ({
        search: '',
        products:[],
        headers: [
          {
            text: 'Capa',
            align: 'left',
            sortable: false,
            value: 'cover',
          },
          { text: 'Nome', value: 'name' },
          { text: 'Artista principal', value: 'artist_name' },              
          { text: 'Data de lançamento', value: 'release_date' },
          { text: 'Status Pagamento', value: 'order.status' },   
          { text: 'Status do Produto', value: 'status' }   , 
             { text: "Ações", value: "actions" }      
        ],
    }),
    beforeCreate:function(){
         this.$store.dispatch('loading')
        productService = ProductService.build();
        productService.get_all({flavor:'video'}).then( e =>{
            if(e.status=="ok"){
                this.products = e.items.products.map( ee=>{
                    ee.order = this.payment_status(ee);
                    if(ee.artist){
                        ee.artist_name = ee.artist.name;
                    }else{
                        ee.artist_name = "nao definido"
                    }
                    return ee;
                });
            }

        }).catch( e =>{
            console.log(e);
        }).finally( () =>{
             this.$store.dispatch('loading', false)
        });
    },
    methods:{
        get_cover_url(item){
            return process.env.VUE_APP_BASE_URL + item.thumbnail;
        },
        payment_status(item){
            if(item.order!=null){
                return item.order;
            }else{
                return {status:"não pago"};
            }
        }
    }
};
</script>